import { render, staticRenderFns } from "./kindChooseViewkvip.vue?vue&type=template&id=488e1c80&scoped=true"
import script from "./kindChooseViewkvip.vue?vue&type=script&lang=js"
export * from "./kindChooseViewkvip.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewkvip.vue?vue&type=style&index=0&id=488e1c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e1c80",
  null
  
)

export default component.exports